const TRUNCATION_HEIGHT = 160;

function openLightbox(lightbox) {
  lightbox.classList.add('is-open');
  lightbox.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeLightbox(lightbox) {
  lightbox.classList.remove('is-open');
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function initCollectionDescriptionLightbox() {
  document.querySelectorAll('[data-collection-description]').forEach(wrapper => {
    const textEl = wrapper.querySelector('.collection-description-text');
    const btn = wrapper.querySelector('.collection-description-read-more');
    if (!textEl || !btn) return;

    const lightbox = document.getElementById(btn.dataset.target);
    if (!lightbox) return;

    if (textEl.scrollHeight <= TRUNCATION_HEIGHT) return;

    textEl.classList.add('is-truncated');
    btn.hidden = false;

    btn.addEventListener('click', () => openLightbox(lightbox));

    lightbox.addEventListener('click', e => {
      if (!e.target.closest('.ux-description-lightbox__panel')) closeLightbox(lightbox);
    });

    lightbox.querySelector('.ux-description-lightbox__close')
      ?.addEventListener('click', () => closeLightbox(lightbox));
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.ux-description-lightbox.is-open').forEach(closeLightbox);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionDescriptionLightbox);
} else {
  initCollectionDescriptionLightbox();
}
